import { render, staticRenderFns } from "./ApiStatusCard.vue?vue&type=template&id=0f338938"
import script from "./ApiStatusCard.vue?vue&type=script&lang=js"
export * from "./ApiStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports